module.exports = __webpack_public_path__ + "img/acqua-palace_DSC_0631.d311f3bc.jpeg";